export { default as OwnerPromotionPage } from './OwnerPromotionPage'
